import { format, formatRelative } from "date-fns";
import { useLearnerContext } from "../../../contexts/LearnerContext";
import { isSubscriptionActive } from "../../../utils/isSubscriptionActive";
import { LEARNER_LICENSE_CONTACT_EMAIL } from "../../../constants";

export const LicenseDetailsField: React.FC = () => {
  const learnerContext = useLearnerContext();

  const isParent = learnerContext.learner?.entitlements?.includes("parent");

  if (
    !learnerContext.learner ||
    learnerContext.learner.accessMethod !== "license" ||
    !learnerContext.learner.subscriptionExpiration
  ) {
    return null;
  }

  const formattedNumLearners =
    learnerContext.learner.subscriptionQuantity === 1
      ? "1 learner"
      : `${learnerContext.learner.subscriptionQuantity || "unknown"} learners`;

  const now = Date.now();
  const expiration = new Date(learnerContext.learner.subscriptionExpiration);
  const diff = expiration.getTime() - now;
  const formattedEndDate =
    Math.abs(diff) < 1000 * 60 * 60 * 24
      ? formatRelative(expiration, now)
      : format(expiration, "PPP");

  if (!isSubscriptionActive(learnerContext.learner)) {
    return (
      <div className="flex flex-col gap-2 text-sm">
        {isParent ? (
          <p>
            Your license for <b>{formattedNumLearners}</b> expired on{" "}
            <b>{formattedEndDate}</b>.
          </p>
        ) : (
          <p>
            Your license expired on <b>{formattedEndDate}</b>.
          </p>
        )}
        <p>
          Please contact{" "}
          <a
            className="text-dm-brand-blue-500 hover:to-dm-brand-blue-600"
            href={`mailto:${LEARNER_LICENSE_CONTACT_EMAIL}`}
          >
            {LEARNER_LICENSE_CONTACT_EMAIL}
          </a>{" "}
          to renew your license.
        </p>
      </div>
    );
  }
  return isParent ? (
    <p className="text-sm">
      Your license for <b>{formattedNumLearners}</b> is active until{" "}
      <b>{formattedEndDate}</b>.
    </p>
  ) : (
    <p className="text-sm">
      Your license is active until <b>{formattedEndDate}</b>.
    </p>
  );
};
